import { render, staticRenderFns } from "./AutresBourses.vue?vue&type=template&id=5804a488&scoped=true"
import script from "./AutresBourses.vue?vue&type=script&lang=js"
export * from "./AutresBourses.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/DemandeBourse.css?vue&type=style&index=0&id=5804a488&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804a488",
  null
  
)

export default component.exports